import { render, staticRenderFns } from "./SAPCustomerMaterialMappingList.vue?vue&type=template&id=a907fc9c&scoped=true&"
import script from "./SAPCustomerMaterialMappingList.vue?vue&type=script&lang=js&"
export * from "./SAPCustomerMaterialMappingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a907fc9c",
  null
  
)

export default component.exports